<template>
  <div class="AllCourses">
    <template v-if="allCourseLists && allCourseLists.length == 0">
        <div class="null">
          <img src="../../../../common/images/search/search-null.png" alt="">
          <p>当前没有课程，快去看看感兴趣的课程把！</p>
        </div>
      </template>
      <template v-else>
        <div class="main">
            <el-table :data="allCourseLists" style="width: 100%">
            <el-table-column label="课程信息">
                <template slot-scope="scope">
                <div class="courses-card" @click="gotoRouterDetaills(scope.row.courseid)">
                    <div class="img"><img v-lazy="scope.row.coverurl" :alt="scope.row.subject"></div>
                    <div class="msg">
                      <p class="text-overflow">{{scope.row.subject}}</p>
                      <!-- <p class="money" v-if="scope.row.feetype == 1">免费</p>
                      <p class="money" v-else>{{scope.row.uprice}}</p> -->
                    </div>
                  </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <div class="position">
                  
                  <template v-if="scope.row.iscomment == 0">
                    <span @click='startpopu(scope.row)'>评价课程</span>
                    <span class="padding">|</span>
                  </template>
                  <!-- 未评价状态 -->

                  <span @click="gotoRouterStudy(scope.row.courseid)">开始学习</span>
                  <span class="padding">|</span>
                  <template>
                    <span @click="participateInJointable(scope.row)" v-if="scope.row.isjointable == 0">加入课表</span>
                    <span @click="participateInJointable(scope.row)" v-else>移出课表</span>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next" :current-page.sync='allCourse.page'  @current-change="handleCurrentChange" :total="rowCount"> </el-pagination>
        </div>
        <Evaluate ref="evaluate" @evaluateSuccess='evaluateSuccess'></Evaluate>
      </template>
  </div>
</template>

<script>
import Evaluate from './../components/Evaluate'
import {getUserAllCourseList, operateJoinCourse} from 'api/personalCenterApi'
import {mapActions} from 'vuex'
export default {
  name: 'AllCourses',
  data () {
    return {
      allCourseLists: [], // 课程列表
      allCourse: {page: 1, pageSize: 10},  // 接口api
      rowCount:1,
      activeAllCourseLists: {}, // 选中的课程列表
    }
  },
  mounted () {
    this.getUserAllCourseLists(1)
  },
  methods: {

     getUserAllCourseLists(page) { // 收藏列表接口
      this.allCourse.page = page
      this.setLoading(true)
      getUserAllCourseList({
        data: this.allCourse,
        success: data => {
          this.setLoading(false)
          this.allCourseLists = data.data.content
          this.rowCount = data.data.pageinfo.rowCount
          // console.log('allCourseLists', data.data)
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
    },
    startpopu(list) { // 评价课程
      // console.log(list)
      this.activeAllCourseLists = list
      this.$refs.evaluate.startPopu(list.courseid)
    },
    evaluateSuccess() { // 课程评价成功
      this.activeAllCourseLists.iscomment = 1
      // this.getUserAllCourseLists(1)
    },
    participateInJointable(item) {  // 加入/移出课表
        this.activeAllCourseLists = item  // 取得列表
        
        let courseid = item.courseid, 
            status = item.isjointable

        if (status == 1) {
            this.$confirm('是否需要将课程移出课表?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                  this.jointableApi(courseid, 2)

              }).catch(() => {})
        } else {
            this.jointableApi(courseid, 1)
        } 

    },
    jointableApi(courseid, status) {  // 加入/移出课表接口调用 1 加入 2 移除
      this.setLoading(true)
      operateJoinCourse({
        data: {courseid: courseid, optype: status},
        success: data => {

          this.setLoading(false)
          if (data.code == '000') {

            this.$message.success('操作成功')

            if (status == 2) {  // 移除课表成功
              this.activeAllCourseLists.isjointable = 0
            } else {  // 加入课表成功
              this.activeAllCourseLists.isjointable = 1
            }
            // this.getUserAllCourseLists(1)
            // this.activeAllCourseLists.isjointable = ''

            // 刷新基本信息统计
            this.$parent.info()

          } else {
            this.$message.error(data.msg)
          }
            
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
      // console.log(courseid, status)
    },
    handleCurrentChange(page) { // 翻页
        this.getUserAllCourseLists(page)
    },
    gotoRouterDetaills(cid) {  // 前往详情页面
      const { href } = this.$router.resolve({
                name: "CourseDetails",
                query: {
                    cid: cid
                }
    })
    window.open(href, '_blank');
    }, 
    gotoRouterStudy(cid) { // 前往学习页面
       const { href } = this.$router.resolve({
                name: "Study",
                query: {
                    courseid: cid
                }})
       window.open(href, '_blank');
    },
    ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
    Evaluate
  }
}
</script>

<style lang="scss" type="text/scss" scope>
.AllCourses {
    .el-table {
      .position {
        span {
          color: #303133;

          &.padding {
            color: #e5e5e5;
          }
          &:hover {
            color: #409EFF;
          }
        }
      }
    }
}
</style>